import uniqBy from "lodash-es/uniqBy.js";
import countBy from "lodash-es/countBy.js";
import { processMediaItem } from "../goliath-media.js";
const sortingArray = ["A", "B", "C", "D", "E", "F", "G"];
function reverseSortedEnergyEfficiencyClasses(products) {
    return products.sort((a, b) => sortingArray.indexOf(b.energyEfficiency.class || "") -
        sortingArray.indexOf(a.energyEfficiency.class || ""));
}
export function productsWithEnergyEfficiency(products) {
    if (!products) {
        return [];
    }
    const filtered = [];
    products.forEach((product) => {
        if (!(!!product.energyEfficiency?.labelImage &&
            !!product.energyEfficiency.class))
            return;
        filtered.push(product);
    });
    return filtered;
}
export function extractedProducts(product) {
    if ("bundledProducts" in product)
        return product?.bundledProducts || [];
    return product ? [product] : [];
}
export function energyEfficiencyClasses(extractedProducts) {
    return reverseSortedEnergyEfficiencyClasses(productsWithEnergyEfficiency(extractedProducts));
}
/**
 * Detect if an offer has at least one product with energy efficiency label.
 * @param offer Either single product or bundled product
 */
export function hasProductWithEnergyEfficiency(offer) {
    const products = extractedProducts(offer.product);
    return productsWithEnergyEfficiency(products).length > 0;
}
const mapEnergyClass = (product) => {
    const document = product?.energyEfficiency?.document;
    const className = product?.energyEfficiency?.class;
    return {
        name: product.name || "",
        familyName: product?.family?.name || "",
        class: className,
        image: processMediaItem(product?.energyEfficiency?.labelImage || undefined),
        documentPath: document?.path?.replace("/public/", "/product-images/") || undefined,
    };
};
/**
 * This function gets all energy-labels for a product or bundle. it returns a list for each variant and the "worst" label as default.
 * @param product
 */
export function getEnergyEfficiencyProduct(product) {
    if (!product)
        return undefined;
    const products = extractedProducts(product);
    if (!products)
        return undefined;
    const productsWithLabel = energyEfficiencyClasses(products);
    if (productsWithLabel.length === 0)
        return undefined;
    const mainEnergyClass = productsWithLabel.find((efficiencyClass) => !!efficiencyClass);
    if (!mainEnergyClass)
        return undefined;
    const uniqueProduct = uniqBy(productsWithLabel, (p) => p.family?.name);
    const getFamilyName = (familyName) => {
        const count = countBy(productsWithLabel, (p) => p.family?.name)[familyName] || 0;
        if (count <= 1)
            return familyName;
        return `${count} × ${familyName}`;
    };
    return {
        ...mapEnergyClass(mainEnergyClass),
        products: uniqueProduct.map((product) => ({
            ...mapEnergyClass(product),
            familyName: getFamilyName(product.family?.name || ""),
        })),
    };
}
